// extracted by mini-css-extract-plugin
export default {"main":"EssaySelectEdit_main__BdRJf","question":"EssaySelectEdit_question__8EQfm","tooltip":"EssaySelectEdit_tooltip__2kx51","select_input":"EssaySelectEdit_select_input__PLcAc"};